var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62688 8.41278H14.4411C14.5738 8.41278 14.6866 8.36634 14.7728 8.28011C14.8591 8.19387 14.9055 8.0811 14.9055 7.94843C14.9055 7.81576 14.8591 7.70299 14.7728 7.61676C14.6866 7.53052 14.5738 7.48409 14.4411 7.48409H2.62025L6.10947 3.99487C6.1957 3.90863 6.24214 3.8025 6.24214 3.67646C6.24214 3.55042 6.20234 3.44429 6.10947 3.35142C6.02323 3.26518 5.9171 3.21875 5.78443 3.21875C5.65176 3.21875 5.55225 3.26518 5.45939 3.35142L1.26701 7.55042C1.20731 7.61013 1.16088 7.67646 1.13434 7.7428C1.10781 7.80913 1.09454 7.8821 1.09454 7.9617C1.09454 8.0413 1.10781 8.11427 1.13434 8.18061C1.16088 8.24694 1.20068 8.31328 1.26701 8.37298L5.46602 12.572C5.55225 12.6582 5.65839 12.7047 5.78443 12.7047C5.91046 12.7047 6.0166 12.6582 6.10947 12.572C6.20897 12.4791 6.25541 12.373 6.24877 12.2403C6.24877 12.1143 6.20234 12.0081 6.10947 11.9153L2.62688 8.42605V8.41278Z",
    fill: "#4B566C",
    stroke: "#4B566C",
    strokeWidth: 0.266667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/Back_Icon.d42c36f27f53b7f78d91095af2eacb44.svg";
export { ForwardRef as ReactComponent };